import React from 'react'

const CalculatorSteps = React.forwardRef((props, ref) => (
    <div ref={ref} className="form-field__steps">
        {props.children}
    </div>
))

export default CalculatorSteps